import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Label from "../../components/label";
import MakeAPICall from "../../apiCalls/common";
import {
  getCalendarDatesByMonthStartingThisWeek,
  getCurrentMonthAndYear,
  getFormattedDate,
  getMomentObjFormmaterWithTimeZone,
  mergeDateAndTimeUsingMomentObj
} from "../../utils/dateTimeHelper";
import CalendarUI from "../../containers/Shift/CalenderUI";
import { addDoctorShiftAPI, deleteDoctorShiftAPI, editDoctorShiftAPI, getDoctorShiftsAPI, getUserProfile } from "../../apiRoutes";
import Loader from "../../components/loader";
import _ from "lodash";
import moment from "moment";
import DropdownMultiCheckbox from "../../components/form/dropDownWithCheckbox";
import { FilterAndProps } from "../../containers/Shift/AddShiftForm";
import { doctorInSchedule } from "../../utils/common";
import CustomModal from "../../components/customModal";

function ShiftsPage({ doctor }) {
  const [isLoading, setIsLoading] = useState(false);
  const [apiCall, setApiCall] = useState(false);
  const [apiCall2, setApiCall2] = useState(false);
  const [apiCall3, setApiCall3] = useState(false);
  const [leafAPICall, setLeafAPICall] = useState(false);
  const [switchAPICall, setSwitchAPICall] = useState(false);
  const [hushAPICall, setHushAPICall] = useState(false);
  const [scheduleFilter, setScheduleFilter] = useState(getScheduleFilterDefault());
  const [calendarDates, setCalendarDates] = useState(getCalendarDatesByMonthStartingThisWeek());
  const [currentMonth, setCurrentMonth] = useState(getCurrentMonthAndYear());
  const [filters, setFilters] = useState();
  const [shiftsByDate, setShiftsByDate] = useState([]);
  const [userProfile, setUserProfile] = useState(null);
  const [isAllDoctorScheduled, setIsAllDoctorScheduled] = useState(true);
  const [showErrorOnDeleteModal, setShowErrorOnDeleteModal] = useState(false);

  function handleShiftFormSubmit(values, isEdit) {
    if (values.shiftDates.length === 0) {
      return;
    }
    const { scheduleFilter, ...data } = values;

    // let shiftDates;
    // if (values.shiftDates && Array.isArray(values.shiftDates) && !isEdit) {
    //   shiftDates = values.shiftDates.map((date) => moment(date).add(1, 'd').toISOString());
    // } else if (!isEdit && values.shiftDates) {
    //   shiftDates = moment(values.shiftDates).add(1, 'd').toISOString();
    // }

    setIsLoading(true);


    const shiftDate = moment(data.shiftDates[0]);

    const dataObj = {
      ...data,
      shiftStartTime: mergeDateAndTimeUsingMomentObj(shiftDate, moment(data.shiftStartTime)),
      shiftEndTime: mergeDateAndTimeUsingMomentObj(shiftDate, moment(data.shiftEndTime)),
      shiftDates: isEdit
        ? data.shiftDates  // If isEdit is true, keep original shiftDates
        : values.shiftDates.map(shiftDate => {
            const result = mergeDateAndTimeUsingMomentObj(moment(shiftDate), moment(data.shiftStartTime));
            return result;
          })
    };    
    
    if (isEdit) {
      dataObj.shiftDate = mergeDateAndTimeUsingMomentObj(moment(data.shiftDates), moment(data.shiftStartTime));;
      delete dataObj.shiftDates;
    }

    console.log("dataObj: ", dataObj)


    if (scheduleFilter.title === "Instant Leaf") {
      callAPI(dataObj, isEdit ? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_LEAF");
    } else if (scheduleFilter.title === "Instant Switch") {
      callAPI(dataObj, isEdit ? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_SWITCH");
    } else if (scheduleFilter.title === "Instant Hush") {
      callAPI(dataObj, isEdit ? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_HUSH");
    }

    // scheduleFilter.forEach((scheduleFilterElement, index) => {
    //   // setTimeout(()=> {
    //   if (scheduleFilterElement.title === "Instant Leaf") {
    //     callAPI(dataObj, isEdit ? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_LEAF");
    //   } else if (scheduleFilterElement.title === "Instant Switch") {
    //     callAPI(dataObj, isEdit ? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_SWITCH");
    //   } else if (scheduleFilterElement.title === "Instant Hush") {
    //     callAPI(dataObj, isEdit ? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_HUSH");
    //   }
    //   // }, index * 1000);
    // });
  }

  function callAPI(dataToSend, API, type) {
    if (type === "INSTANT_LEAF") {
      setLeafAPICall({
        reqType: "POST",
        reqURL: API,
        dataObj: { shiftFor: "INSTANT_LEAF", ...dataToSend },
        params: {},
        headers: {},
        successCallback: res => {
          setIsLoading(false);
          getDoctorShifts();
        },
        failureCallback: err => {
          setIsLoading(false);
        },
        showErrPopup: true
      });
    } else if (type === "INSTANT_SWITCH") {
      setSwitchAPICall({
        reqType: "POST",
        reqURL: API,
        dataObj: { shiftFor: "INSTANT_SWITCH", ...dataToSend },
        params: {},
        headers: {},
        successCallback: res => {
          setIsLoading(false);
          getDoctorShifts();
        },
        failureCallback: err => {
          setIsLoading(false);
        },
        showErrPopup: true
      });
    } else if (type === "INSTANT_HUSH") {
      setHushAPICall({
        reqType: "POST",
        reqURL: API,
        dataObj: { shiftFor: "INSTANT_HUSH", ...dataToSend },
        params: {},
        headers: {},
        successCallback: res => {
          setIsLoading(false);
          getDoctorShifts();
        },
        failureCallback: err => {
          setIsLoading(false);
        },
        showErrPopup: true
      });
    }
  }

  function getDoctorShifts(calendarDatesParam, filters) {
    const startDate = calendarDatesParam ? calendarDatesParam[0][0].date : calendarDates[0][0].date;
    const totalArrayLength = calendarDatesParam ? calendarDatesParam.length : calendarDates.length;
    const endDate = calendarDatesParam ? calendarDatesParam[totalArrayLength - 1][6]["date"] : calendarDates[totalArrayLength - 1][6]["date"];

    const dataToSend = {
      shiftFor: getDataToSend(),
      filters: {
        ...(filters || {}), doctorId: doctor._id
      },
      startDate: getMomentObjFormmaterWithTimeZone(startDate, "DD/MM/YYYY").startOf("day").toISOString(),
      endDate: getMomentObjFormmaterWithTimeZone(endDate, "DD/MM/YYYY").endOf("day").toISOString()
    };

    setIsLoading(true);

    setApiCall2({
      reqType: "POST",
      reqURL: getDoctorShiftsAPI,
      dataObj: dataToSend,
      params: {},
      headers: {},
      successCallback: res => {
        const shifts = res.data?.data || [];
        if (isAllDoctorScheduled) {
          shifts.forEach(shift => {
            shift.shiftDate = getFormattedDate(shift.shiftDate, "DD/MM/YYYY");
          });
          const shiftsGroup = _.groupBy(shifts, "shiftDate");
          setShiftsByDate(shiftsGroup);
        } else {
          const filteredShifts = shifts.filter(shift => shift.doctorId._id === doctor._id);
          filteredShifts.forEach(shift => {
            shift.shiftDate = getFormattedDate(shift.shiftDate, "DD/MM/YYYY");
          });
          const shiftsGroup = _.groupBy(filteredShifts, "shiftDate");
          setShiftsByDate(shiftsGroup);
        }
        setIsLoading(false);
      },
      failureCallback: err => {
        setIsLoading(false);
      }
    });
    setApiCall3({
      reqType: "GET",
      reqURL: getUserProfile,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        setUserProfile(res.data.data[0])
        setIsLoading(false);
      },
      failureCallback: err => {
        setIsLoading(false);
      }
    });
  }

  function deleteShift(shiftId) {
    setIsLoading(true);
    setApiCall({
      reqType: "POST", reqURL: deleteDoctorShiftAPI, dataObj: {
        shiftId: shiftId
      }, params: {}, headers: {}, successCallback: res => {
        setIsLoading(false);
        getDoctorShifts();
      }, failureCallback: err => {
        if (err.message === "This doctor has a booking during this shift") {
          setShowErrorOnDeleteModal(true);
        }
        setIsLoading(false);
      },
      showErrPopUp: false
    });
  }

  function getNextMonthCalender(filters) {
    const nextMonth = moment(calendarDates[0][0].date, "DD/MM/YYYY").add(4, "weeks");
    const newCalendarDates = getCalendarDatesByMonthStartingThisWeek(nextMonth);
    setCalendarDates(newCalendarDates);
    getDoctorShifts(newCalendarDates, filters);
  }

  function getPreviousMonthCalender(filters) {
    const previousMonth = moment(calendarDates[0][0].date, "DD/MM/YYYY").subtract(4, "weeks");
    const newCalendarDates = getCalendarDatesByMonthStartingThisWeek(previousMonth);
    setCalendarDates(newCalendarDates);
    getDoctorShifts(newCalendarDates, filters);
  }

  function getScheduleFilterDefault() {
    const scheduleFilters = [];

    if (doctor.isAccessToInstantSwitch) {
      scheduleFilters.push(FilterAndProps.find(item => item.title.includes("Switch")));
    }

    if (doctor.isAccessToInstantSwitchMC) {
      scheduleFilters.push(FilterAndProps.find(item => item.title.includes("Leaf")));
    }

    if (doctor.isAccessToInstantHush) {
      scheduleFilters.push(FilterAndProps.find(item => item.title.includes("Hush")));
    }

    return scheduleFilters;
  }


  // Old version
  // function getNextMonthCalender(filters) {
  //   let nextMonthNumber = getNextMonthFrom(currentMonth);
  //   let newCalendarDates = getCalendarDatesByMonth(nextMonthNumber.month, nextMonthNumber.year);
  //   setCurrentMonth(nextMonthNumber);
  //   setCalendarDates(newCalendarDates);
  //   getDoctorShifts(newCalendarDates, filters);
  // }
  //
  // function getPreviousMonthCalender(filters) {
  //   let previousMonthNumber = getPreviousMonthFrom(currentMonth);
  //   let newCalendarDates = getCalendarDatesByMonth(previousMonthNumber.month, previousMonthNumber.year);
  //   setCurrentMonth(previousMonthNumber);
  //   setCalendarDates(newCalendarDates);
  //   getDoctorShifts(newCalendarDates, filters);
  // }

  useEffect(() => getDoctorShifts(calendarDates, filters), [scheduleFilter, filters]);

  useEffect(() => getDoctorShifts(), []);

  function getDataToSend() {
    const scheduleDataToSend = [];
    for (const item of scheduleFilter) {
      if (item.title === "Instant Leaf" && doctor.isAccessToInstantSwitchMC) {
        scheduleDataToSend.push("INSTANT_LEAF");
      } else if (item.title === "Instant Switch" && doctor.isAccessToInstantSwitch) {
        scheduleDataToSend.push("INSTANT_SWITCH");
      } else if (item.title === "Instant Hush" && doctor.isAccessToInstantHush) {
        scheduleDataToSend.push("INSTANT_HUSH");
      }
    }
    return scheduleDataToSend;
  }

  const applyDoctorsScheduledFilter = event => {
    const checked = event.target.checked;
    setIsAllDoctorScheduled(checked);
  };

  useEffect(() => {
    getDoctorShifts(calendarDates, filters);
  }, [isAllDoctorScheduled, filters, calendarDates]);

  return (<div className="row doctor-shifts-page p-2 pb-4 mb-5">
    <div className="row w-100 p-0 m-0 border-bottom pb-2">
      <div className="col-sm-12 pt-3 pl-3 pb-2">
        <Label title="Instant Extras Shifts" className="big" />
      </div>
    </div>

    <div className="col-sm-12 pl-2 pt-4">
      <Label title={"Schedule "} className={"w-100 ml-1 mb-0"} />
      <DropdownMultiCheckbox
        isMultiple={true}
        defaultValue={scheduleFilter}
        className="min-w-200 mx-1"
        placeholder=""
        onChange={setScheduleFilter}
        value={scheduleFilter}
        optionList={FilterAndProps.filter(filter => doctorInSchedule(doctor, filter))}
      />
    </div>
    <div className="col-sm-12 calendarUI-container">
      <CalendarUI calendarDates={calendarDates} shiftsByDate={shiftsByDate} doctorList={[doctor]}
        handleShiftFormSubmit={(formData, isEdit) => handleShiftFormSubmit(formData, isEdit)}
        getPreviousMonthCalender={(filter) => getPreviousMonthCalender(filter)}
        getNextMonthCalender={(filter) => getNextMonthCalender(filter)}
        deleteShift={(id) => deleteShift(id)} clearFilter={() => setScheduleFilter([])}
        handleFilterChange={setFilters} scheduleFilter={scheduleFilter}
        applyDoctorsScheduledFilter={applyDoctorsScheduledFilter}
        isAllDoctorScheduled={isAllDoctorScheduled} timeZone={userProfile?.timeZone} />
    </div>
    <CustomModal
      title="Instant Consult"
      cancelText="Okay"
      openModal={showErrorOnDeleteModal}
      cancelEvent={() => setShowErrorOnDeleteModal(false)}
      useOneButton={true}
      modalBodyContent={<div style={{ textAlign: "center" }}>
        <p className="secondary-font black-light-font-color"><strong>Cannot Delete Shift</strong></p>
        <p>You have a booking during this shift; contact support for assistance</p>
        <p>Once bookings during this shift are re-scheduled, you will be able to delete this shift</p>
      </div>}
    />
    <MakeAPICall apiParam={apiCall} />
    <MakeAPICall apiParam={apiCall2} />
    <MakeAPICall apiParam={apiCall3} />
    <MakeAPICall apiParam={leafAPICall} />
    <MakeAPICall apiParam={switchAPICall} />
    <MakeAPICall apiParam={hushAPICall} />
    <Loader loading={isLoading} />
  </div>);
}

const mapStateToProps = props => ({
  commonReducers: props.commonReducers, doctor: props.auth?.user?.userData
});

export default connect(mapStateToProps, null)(ShiftsPage);
